import { getMatchTime } from '@ms/components/match/composables/useMatchTime.js'
import { isLiveMatch } from '@ms/components/match/status.js'

/**
 * 获取 live 比赛展示用的比分
 * @param  {Object} event event 对象
 * @return {Array}        示例：[[1, 2]] 或者 [[1, 2], [1, 0], [15, 0]]
 */
export const getEventShowScores = (event = {}) => {
  if (!isLiveMatch(event.status) || !event.scoreOfWholeMatch) return

  const result = []
  const { sportId, scoreOfWholeMatch, scoreOfSection, scoreInCurrentSection } = event

  // 整场的比分
  const wholeScores = (scoreOfWholeMatch || '0:0').split(':')

  result.push(wholeScores)

  // 节比分: 只有 Tennis, volleyball, table tennis 显示节比分(显示最后一个比分)
  const ids = [
    'sr:sport:5',
    'sr:sport:23',
    'sr:sport:20',
    'sr:sport:196',
    'sr:sport:31' // badminton
  ]
  if (ids.includes(sportId) && scoreOfSection) {
    let scores = scoreOfSection
    if (typeof scores === 'string') {
      scores = JSON.parse(scores)
    }
    const sectionScores = scores[scores.length - 1].split(':')
    result.push(sectionScores)
  }

  // 小节比分: 只有 Tennis 显示小节比分
  if ((sportId === 'sr:sport:5' || sportId === 'sr:sport:196') && scoreInCurrentSection) {
    const currentSectionScores = scoreInCurrentSection.split(':')
    result.push(currentSectionScores)
  }

  return result
}

/**
 * 获取比赛展示用的状态
 * @param  {Object} event event   对象
 * @param  {Array} excludeStatus  待排除的 status description
 * @return {String}               比赛状态
 */
export const getEventShowStatus = (event = {}, excludeStatus = null) => {
  const { sportId, statusDescription } = event
  switch (sportId) {
    case 'sr:sport:1': // Soccer
      if (excludeStatus && excludeStatus.includes(statusDescription)) {
        return ''
      } else {
        return statusDescription
      }
    default:
      // 当前比赛阶段
      return statusDescription || ''
  }
}

/**
 * 获取比赛展示用的时间
 * @param  {Object} event event 对象
 * @return {String}       注意返回值可能为空
 */
export const getEventShowTime = (event = {}, type = 'HH:mm') => {
  return getMatchTime(event, type)
}

/**
 * 判断当前比赛异常状态显示
 * @param  {[type]} event [description]
 * @return {[type]}       [description]
 */
export const eventAbnormalStatus = (status) => {
  const abnormalStatusList = {
    5: 'Cancelled',
    6: 'Abandonded',
    7: 'Delayed',
    9: 'Interrupted',
    10: 'Postponed'
  }
  return abnormalStatusList[status]
}
